import { render } from "./release-status.vue?vue&type=template&id=8151f7cc"
import script from "./release-status.vue?vue&type=script&lang=js"
export * from "./release-status.vue?vue&type=script&lang=js"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__